(() => {
  const DRAWER_SELECTOR = 'quick-cart-drawer';
  const SWATCH_LINK_SELECTOR = 'a.product-option__link';

  let controller = null;

  function getFetchPrefix() {
    // matches theme logic
    let prefix = '';
    if (window.Shopify?.routes?.root && window.Shopify.routes.root.includes(`/${window.Shopify?.locale}/`)) {
      prefix = `/${window.Shopify.locale}`;
    }
    return prefix;
  }

  function setLoading(drawerEl, isLoading) {
    drawerEl.classList.toggle('is-loading', isLoading);
    drawerEl.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  async function fetchQuickCartView(productUrl) {
    // productUrl might be absolute; normalize to path
    const u = new URL(productUrl, window.location.origin);
    const path = u.pathname;

    controller?.abort();
    controller = new AbortController();

    const prefix = getFetchPrefix();
    const res = await fetch(`${prefix}${path}/?view=quick-cart`, {
      signal: controller.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) throw new Error(`Quick cart fetch failed: ${res.status}`);
    return await res.text();
  }

  function replaceQuickCartProduct(drawerEl, htmlText) {
    const tmp = document.createElement('div');
    tmp.innerHTML = htmlText;

    const newQuickCartProduct = tmp.querySelector('.quick-cart-product');
    if (!newQuickCartProduct) throw new Error('Missing .quick-cart-product in ?view=quick-cart response');

    const main = drawerEl.querySelector('.quick-cart-drawer__main');
    if (!main) throw new Error('Missing .quick-cart-drawer__main in drawer');

    // Clear + inject
    main.innerHTML = '';
    main.appendChild(newQuickCartProduct);

    // Re-init Swiper exactly like theme does
    try {
      if (drawerEl.sliderInstance?.destroy) {
        drawerEl.sliderInstance.destroy(true, true);
      }
    } catch (_) {}

    if (window.Swiper) {
      drawerEl.sliderInstance = new Swiper('.quick-cart-drawer__media-swiper', {
        slidesPerView: 1.25,
        spaceBetween: 8,
        freeMode: { enabled: true },
        breakpoints: { 750: { slidesPerView: 2 } }
      });
    }

    // Ensure the new <product-card> upgrades and initializes
    const pc = drawerEl.querySelector('product-card');
    if (pc && typeof pc.init === 'function') pc.init();

    // Re-init Shopify payment buttons if present
    if (window.Shopify?.PaymentButton?.init) {
      window.Shopify.PaymentButton.init();
    }
  }

  document.addEventListener(
    'click',
    async (e) => {
      const drawerEl = e.target.closest(DRAWER_SELECTOR);
      if (!drawerEl) return;

      const swatchLink = e.target.closest(SWATCH_LINK_SELECTOR);
      if (!swatchLink) return;

      // Stop navigation
      e.preventDefault();
      e.stopPropagation();

      try {
        setLoading(drawerEl, true);
        const html = await fetchQuickCartView(swatchLink.href);
        replaceQuickCartProduct(drawerEl, html);
      } catch (err) {
        // AbortError is normal if user clicks multiple swatches quickly
        if (err.name !== 'AbortError') {
          console.error('[QuickCart] Swatch reload failed:', err);
          window.location.href = swatchLink.href; // fallback
        }
      } finally {
        setLoading(drawerEl, false);
      }
    },
    { capture: true }
  );
})();
